import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

class BackButton extends Component {
  render() {
    return (
      <div className="f0 back-button">
        <FontAwesomeIcon icon={faArrowLeft} size={'sm'} onClick={this.props.goBack} />
      </div>
    );
  }
}

export default withRouter(BackButton);
